import { LOGIN_SESSION_WINDOW_UNTIL_KEY } from '../assets/constants'

const IST_OFFSET_MS = (5 * 60 + 30) * 60 * 1000

function getNextSixAmIstMs(nowMs: number = Date.now()): number {
	const ist = new Date(nowMs + IST_OFFSET_MS)
	const y = ist.getUTCFullYear()
	const m = ist.getUTCMonth()
	const d = ist.getUTCDate()
	const todaySixAm = Date.UTC(y, m, d, 6, 0, 0, 0) - IST_OFFSET_MS
	if (nowMs < todaySixAm) return todaySixAm
	return Date.UTC(y, m, d + 1, 6, 0, 0, 0) - IST_OFFSET_MS
}

/** Persist session cut-off as the next 6am Asia/Kolkata. */
export function setLoginSessionWindow(): void {
	try {
		localStorage.setItem(LOGIN_SESSION_WINDOW_UNTIL_KEY, String(getNextSixAmIstMs()))
	} catch {
		// ignore storage failures
	}
}

function getSessionUntilMs(): number | null {
	try {
		const raw = localStorage.getItem(LOGIN_SESSION_WINDOW_UNTIL_KEY)
		if (!raw) return null
		const until = Number(raw)
		if (!Number.isFinite(until)) return null
		// Cap leftover rolling-24h values so they cannot outlive the next 6am IST.
		const capped = Math.min(until, getNextSixAmIstMs())
		if (capped !== until) {
			localStorage.setItem(LOGIN_SESSION_WINDOW_UNTIL_KEY, String(capped))
		}
		return capped
	} catch {
		return null
	}
}

export function isLoginSessionWindowValid(): boolean {
	const until = getSessionUntilMs()
	return until != null && Date.now() < until
}

export function getMsUntilLoginSessionExpiry(): number | null {
	const until = getSessionUntilMs()
	if (until == null) return null
	const ms = until - Date.now()
	return ms > 0 ? ms : null
}

export function clearLoginSessionWindow(): void {
	try {
		localStorage.removeItem(LOGIN_SESSION_WINDOW_UNTIL_KEY)
	} catch {
		// ignore
	}
}
